export const myDriveApi = {
    createFolder: 'v1/api/userFileMaster/createFolder',
    uploadFile: 'v1/api/userFileMaster/upload',
    updateFile: 'v1/api/userFileMaster/updateFile?',
    getFolderFile: 'v1/api/userFileMaster/files',
    fileDetails: 'v1/api/userFileMaster/fileDetails?Id=',
    updateFolder: 'v1/api/userFileMaster/updateFolder?Id=',
    removeFolder: 'v1/api/userFileMaster/removeFolder?Id=',
    removeFile: 'v1/api/userFileMaster/removeFile?Id=',
}